import Page from "components/page/Page";
import React, { useState } from "react";
import { useHistory } from "react-router";
import WebsiteBuilderTemplate, { IWebsiteBuilderTemplate } from "./WebsiteBuilderTemplate";
import "./websiteBuilderTemplates.scss";
import { t } from "i18next";

export default function WebsiteBuilderTemplates() {
  const history = useHistory();

  const [websiteBuilderTemplates] = useState<IWebsiteBuilderTemplate[]>([
    {
      id: 1,
      src: "../../../public/images/websiteBuilder/configuration/templates/website_builder_minimalist_template.png",
      title: "Minimalist",
    },
    {
      id: 2,
      src: "../../../public/images/websiteBuilder/configuration/templates/website_builder_scandinavian_template.png",
      title: "Scandinavian",
    },
    {
      id: 3,
      src: "../../../public/images/websiteBuilder/configuration/templates/website_builder_traditional_template.png",
      title: "Traditional",
    },
    {
      id: 4,
      src: "../../../public/images/websiteBuilder/configuration/templates/website_builder_contemporary_template.png",
      title: "Contemporary",
    },
  ]);

  return (
    <Page
      narrow
      title={t("Choose a website template")}
      subtitle={t("Manage your website, pages, and domain.")}
      breadcrumbs={[
        {
          prefix: true,
          label: t("Go back"),
          url: "/admin/website-builder",
        },
      ]}
    >
      <div className="website-builder-templates">
        {websiteBuilderTemplates?.map(template => {
          return (
            <WebsiteBuilderTemplate
              key={template.id}
              template={template}
              onClick={() => history.push(`/admin/website-builder/templates/${template.id}`)}
            />
          );
        })}
      </div>
    </Page>
  );
}
